import { useMutation } from '@tanstack/react-query';
import {
  BidvBankTransferService,
  SubmitTransferDto,
  SubmitTransferEntity,
} from 'services/openapi';

export const useBidvSubmitTransferMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<SubmitTransferEntity, Error, SubmitTransferDto>({
      mutationFn: (variables: SubmitTransferDto) => {
        return BidvBankTransferService.bidvBankTransferControllerSubmitTransfer(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
